// "Which currencies are there, and in what order" — the whole-registry case of
// the rule `registryOrder` states.
//
// The provider next door answers the OTHER question the same registry read
// serves ("what does GOLD look like"), and answers it from the seed when
// nothing is configured. This one cannot: a picker needs the row SET and
// `sort_order`, which the presentation shape drops.
//
// It delegates rather than re-deriving. Two pickers that each re-implemented
// "registry order, narrowed to codes the contract knows, falling back to the
// contract" is how one of them ends up offering a currency the other does not.

import { useRegistryOrderedCurrencies } from "@/components/currency/registryOrder";
import { CURRENCY_CODES, type CurrencyCode } from "@/currency";

/**
 * The currencies this deployment actually carries, in the order the operator
 * put them in (`sort_order`, the field the /currencies page exists to set).
 *
 * This is `useRegistryOrderedCurrencies` with no policy narrowing: a filter
 * that reports on money already moved excludes nothing, unlike a money FORM,
 * which must not offer a currency the server would refuse. When the registry
 * is unreadable (loading, no CURRENCY_VIEW, failed read) the contract's own
 * order stands in — a picker offering nothing is a worse failure than one
 * ordered differently than an operator would like.
 */
export function useRegistryCurrencyCodes(): CurrencyCode[] {
  return useRegistryOrderedCurrencies(CURRENCY_CODES);
}
